// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OvQj","col":"styles_col__1fEcB"};